window.theme = window.theme || {};

(function() {
  'use strict';

  // Cowlendar adds a `cow_countdown` line item property to booking products
  // (e.g. the seaweed baths). Its value is the UTC ISO timestamp at which the
  // held slot expires. cart-item.liquid hides the raw property and renders a
  // [data-booking-hold] element instead; this turns that into a live timer.
  //
  // The cart markup is replaced wholesale whenever the AJAX cart re-renders,
  // so this re-scans the DOM on every tick rather than binding to elements.

  var SELECTOR = '[data-booking-hold]';
  var TICK_MS = 500;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return pad(minutes) + ':' + pad(seconds);
  }

  function updateElement(el) {
    var expiresAt = new Date(el.getAttribute('data-booking-hold-expires')).getTime();
    if (isNaN(expiresAt)) {
      el.setAttribute('hidden', 'hidden');
      return;
    }

    var remaining = expiresAt - Date.now();
    var timer = el.querySelector('[data-booking-hold-timer]');

    if (remaining > 0) {
      el.classList.remove('cart__booking-hold--expired');
      if (timer) timer.textContent = formatRemaining(remaining);
    } else {
      el.classList.add('cart__booking-hold--expired');
      if (timer) timer.textContent = '';
    }

    el.setAttribute('data-booking-hold-ready', 'true');
  }

  function tick() {
    var elements = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      updateElement(elements[i]);
    }
  }

  function init() {
    tick();
    setInterval(tick, TICK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
